"use client";

import React from "react";
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface JsonErrorDisplayProps {
  rawValue: string;
  error: string;
}

/**
 * Shows raw invalid JSON string with error message
 * Provides guidance for fixing the JSON
 */
export function JsonErrorDisplay({ rawValue, error }: JsonErrorDisplayProps) {
  return (
    <div className="space-y-3">
      <Alert variant="destructive">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription>
          <div className="space-y-2">
            <p className="font-semibold">Invalid JSON Format</p>
            <p className="text-sm">{error}</p>
          </div>
        </AlertDescription>
      </Alert>

      <div className="bg-muted p-3 rounded-md border border-destructive/20">
        <p className="text-xs font-semibold text-muted-foreground mb-2">Current Value:</p>
        <pre className="text-xs overflow-auto max-h-32 text-destructive break-words whitespace-pre-wrap">
          {rawValue}
        </pre>
      </div>

      <p className="text-xs text-muted-foreground">
        Fix the JSON by adding or updating key-value pairs below. The system will validate and save
        the corrected data.
      </p>
    </div>
  );
}
